import { Type } from "class-transformer";
import { EnaioObjectDefTranslation } from "./EnaioObjectDefTranslation";
import { EnaioTableDataType } from "./EnaioTableDataType";

export class EnaioGuiFieldTableColumn {
    position = 0;
    guid = "";
    name = "";
    internalName = "";
    dbName = "";
    id = 0;
    type: EnaioTableDataType;
    length = 0;
    colWidth = 0;
    colPos = 0;
    color = 0;
    textAlign = 0;
    catalogueType = 0;
    linkId = 0;
    valuesId = "";
    readOnly = false;
    listItems: string[];
    @Type(() => EnaioObjectDefTranslation)
    translatedNames: EnaioObjectDefTranslation[];
}
